(function () {
    'use strict';

    var module = angular.module('uwAgenda.ringfoon');
    module.controller('DialModalController', ['$uibModalInstance', 'CallsService', DialModalControllerFn]);

    /* controller for Dialing a Number */
    function DialModalControllerFn($uibModalInstance, CallsService) {
        /* jshint validthis:true */
        var vm = this;

        // phonenumber
        vm.phonenumber = null;
        // caption 
        vm.caption = null;
        // immediate call ?
        vm.immediate = true;

        activate();

        /* load work */
        function activate() {
            vm.phonenumber = CallsService.outgoing.phonenumber;
            vm.caption = CallsService.outgoing.caption;
            vm.immediate = CallsService.outgoing.immediate;
        } // activate


        // close
        vm.close = function () {
            $uibModalInstance.dismiss();
        };


        // make a new call
        vm.call = function(invoiced) {
            CallsService.outgoing.invoiced = invoiced;
            $uibModalInstance.close(invoiced);
        };

    }
})();
